export const TaxesSystems = [
    { name: 'notSelected', value: 0 },
    { name: 'emirates', value: 1 },
    // {name: 'saudi', value: 2},
    // {name: 'turkey', value: 7},
    { name: 'egypt', value: 8 },
    // {name: 'jordan', value: 9},
    { name: 'syria', value: 10}
];